import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { LicenceInformation } from './types.tsx';

export const getLicenceInformation = (cloudId: string): Promise<LicenceInformation> =>
	fetchJson(`/gateway/api/xflow/${cloudId}/license-information`, {
		method: 'GET',
	});
